import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Banner from '@/pages/home/components/Banner';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import LatestAndHot from '@/pages/home/components/LatestAndHot';
import SiteIntro from '@/pages/home/components/SiteIntro';
import { getHot, getLatest } from '@/lib/media';

export default function Home() {
  const bannerItems = getHot(5);
  const latestItems = getLatest(6);
  const hotItems = getHot(6);

  return (
    <div className="min-h-screen flex flex-col bg-background-100">
      <Header />
      <main className="flex-1 pb-12">
        <Banner items={bannerItems} />
        <CategoryEntries />
        <LatestAndHot latest={latestItems} hot={hotItems} />
        <SiteIntro />
      </main>
      <Footer />
    </div>
  );
}